import React from 'react';
import './Speakers from.css';
import summits from "../../img/SF/7summits.png";
import agorapulse from "../../img/SF/agorapulse.png";
import Covalent from "../../img/SF/Covalent.png";
import DezJob from "../../img/SF/DezJob.png";
import Fjord from "../../img/SF/Fjord.png";
import Frog from "../../img/SF/Frog.png";
import Klint from "../../img/SF/Klint.png";
import Netgen from "../../img/SF/Netgen.png";
import swissdev from "../../img/SF/swissdev.png";
import Teccelerator from "../../img/SF/Teccelerator.png";
import UBX from "../../img/SF/UBX.png";
import UXtoday from "../../img/SF/UXtoday.png";
import Google from "../../img/SF/Google.png";
import IBM from "../../img/SF/IBM.png";
import Microsoft from "../../img/SF/Microsoft.png";
import Figma from "../../img/SF/Figma.png";
import NodeSource from "../../img/SF/NodeSource.png";
import AccentureSong from "../../img/SF/AccentureSong.png";
import Ubisoft from "../../img/SF/Ubisoft.png";

const SpeakersFrom = (props) => {
    const state = {
        Speakers_item: [
            {
                img: Google,
            },
            {
                img: IBM,
            },
            {
                img: Microsoft,
            },
            {
                img: Figma,
            },
            {
                img: NodeSource,
            },
            {
                img: AccentureSong,
            },
            {
                img: Ubisoft,
            },
            {
                img: Netgen,
            },
            {
                img: UXtoday,
            },
            {
                img: agorapulse,
            },
            {
                img: Covalent,
            },
            // {
            //     img: summits,
            // },
        ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item speakers_from_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Speakers logo" />
            </div>
        );
    };

    return (
        <div className="speakers_from_wrap">
            <div className="container">
                <h2>Speakers <span className='title_gradient'>from</span> previous event</h2>
                <div className="speakers_from">
                    {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
                </div>
            </div>
        </div>
    );
};

export default SpeakersFrom;